// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';

export const Policy = styled.div`
  max-width: 760px;
  margin: 0 auto;
  padding: 40px 20px 64px;

  ${({ theme }) => theme.breakpoints.desktop} {
    padding: 64px 32px 96px;
  }
`;

export const Eyebrow = styled.p`
  margin: 0 0 10px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.grafanaOrange};
`;

export const Title = styled.h1`
  margin: 0 0 8px;
  font-size: clamp(30px, 5vw, 44px);
  font-weight: 800;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors.ink};
`;

export const Updated = styled.p`
  margin: 0 0 32px;
  padding-bottom: 24px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.inkMuted};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

export const SectionTitle = styled.h2`
  margin: 32px 0 10px;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.colors.ink};
`;

export const Text = styled.p`
  margin: 0 0 14px;
  font-size: 15px;
  line-height: 1.75;
  color: ${({ theme }) => theme.colors.inkMuted};
`;

export const DemoNote = styled.div`
  margin-top: 40px;
  padding: 16px 20px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.surfaceMuted};
  font-size: 13px;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.inkMuted};
`;

export const NotFound = styled.div`
  padding: 80px 0;
  text-align: center;

  a {
    color: ${({ theme }) => theme.colors.grafanaOrange};
    font-weight: 600;
  }
`;
